import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import Page from '../../components/Page/Page';
import useGoToTrackPage from '../../hooks/trackPackage/useGoToTrackPage';
import useTrackPackages from '../../hooks/trackPackage/useSetTrackPackage';
import {
  TrackPackageDataType,
  TrackPackageSchema,
} from '../../models/trackPage/trackPackage.model';
import PackageDetails from './PackageDetails/PackageDetails';
// import SignToAccessMoreDetails from './SignToAccessMoreDetails/SignToAccessMoreDetails';
import TrackPackageForm from './TrackPackageForm/TrackPackageForm';
import ComponentHeader from '../../components/ComponentHeader/ComponentHeader';
import DownloadProofOfDelivery from './ProofOfDelivery/DownloadProofOfDelivery';
import ParcelContent from './ParcelContent/ParcelContent';
import { useAppSelector } from '../../redux/store';

const Track = () => {
  const { goToTrackPage } = useGoToTrackPage();
  const { trackPackages, trackPackageLoading } = useTrackPackages();
  const trackingInfo = useAppSelector((state) => state.trackPackage.trackPackage);

  const { trackingId } = useParams();

  useEffect(() => {
    if (trackingId) {
      trackPackages(trackingId);
    }
    // eslint-disable-next-line
  }, [trackingId]);

  const onSubmit = async (values: TrackPackageDataType) => {
    goToTrackPage(values.trackingId);
  };

  return (
    <Page title='CML | Track Package'>
      <Container className={trackingId === undefined ? 'no-tracking' : ''}>
        <ComponentHeader align='left' text='Track Package' description='Track your parcel effortlessly. Use your unique tracking ID sent to your email to stay informed of delivery progress' />
        {/* <HeaderContents>
          <Header>Track Parcel</Header>
          <Description>Track your parcel effortlessly. Use your unique tracking ID sent to your email to stay informed of delivery progress </Description>
        </HeaderContents> */}
        <TrackPackageForm
          trackPackageInitialValues={{ trackingId: trackingId ?? '' }}
          TrackPackageSchema={TrackPackageSchema}
          onSubmit={onSubmit}
          trackPackageLoading={trackPackageLoading}
        />
        {trackingId && trackingInfo && (
          <>
            <PackageDetails trackingInfo={trackingInfo} />
            <ParcelContent trackingInfo={trackingInfo} />
            <DownloadProofOfDelivery trackingInfo={trackingInfo} />
          </>
        )}
        {!trackPackageLoading && !trackingInfo && trackingId && (
          <CantTrackPackage>
            Ooops!! Can't track parcel {trackingId}.
          </CantTrackPackage>
        )}
      </Container>
    </Page>
  );
};

export default Track;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin: 73px 0 60px;

  &.no-tracking {
    height: 60vh;
  }
`;

// const HeaderContents = styled.div``;

// const Header = styled.div`
//   font-size: 48px;
//   font-weight: 700;

//   @media (max-width: 884px) {
//     font-size: 40px;
//   }
// `;

// const Description = styled.div`
//   color: #292929;
// `;

const CantTrackPackage = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.redFontColor};
  font-weight: 500;
`;
